export default __webpack_public_path__ + "static/media/12.3e9d737c.md";